import { useState, ReactNode } from 'react';

interface AccordionItemProps {
  title: string;
  impact?: number;
  children: ReactNode;
  defaultOpen?: boolean;
}

export function AccordionItem({ title, impact, children, defaultOpen = false }: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors min-h-touch"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-3 flex-1 text-left">
          <span className={`transform transition-transform ${isOpen ? 'rotate-90' : ''}`}>
            ▶
          </span>
          <span className="font-semibold text-gray-900">{title}</span>
        </div>
        {impact !== undefined && (
          <span className="risk-badge-high ml-2">
            Impact: {Math.round(impact * 100)}%
          </span>
        )}
      </button>

      {isOpen && (
        <div className="p-4 bg-white border-t border-gray-200">
          {children}
        </div>
      )}
    </div>
  );
}

interface AccordionProps {
  children: ReactNode;
}

export function Accordion({ children }: AccordionProps) {
  return (
    <div className="flex flex-col gap-3">
      {children}
    </div>
  );
}
